import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useStore } from "../context/StoreContext";

const L = {
  fr: { code: "Erreur 404", title: "Cette page s'est évaporée.", body: "Le lien est peut-être ancien ou la page a changé d'adresse. Retrouvez nos rituels depuis l'accueil.", home: "Retour à l'accueil", products: "Voir les produits", contact: "Nous contacter" },
  en: { code: "Error 404", title: "This page has evaporated.", body: "The link may be old or the page has moved. Find our rituals from the homepage.", home: "Back to home", products: "See products", contact: "Contact us" },
};

export default function NotFound() {
  const { lang } = useStore();
  const l = L[lang];
  return (
    <div className="min-h-screen pt-40 pb-24 px-6 lg:px-14 xl:px-24 max-w-3xl" data-testid="not-found-page">
      <p className="text-[11px] font-mono uppercase tracking-[0.3em] text-[#C85A32] mb-4">{l.code}</p>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-stone-900 leading-[1.05]">{l.title}</h1>
      <p className="mt-6 text-base text-stone-600 max-w-lg leading-relaxed">{l.body}</p>
      <div className="mt-10 flex flex-wrap gap-3">
        <Link to="/" data-testid="not-found-home" className="inline-flex items-center gap-2 rounded-full bg-stone-900 text-[#FAF7F2] px-7 py-3.5 text-[11px] uppercase tracking-[0.2em] hover:bg-[#C85A32] transition-colors"><ArrowLeft size={13} /> {l.home}</Link>
        <Link to="/#products" className="inline-flex items-center rounded-full border border-stone-300 px-7 py-3.5 text-[11px] uppercase tracking-[0.2em] text-stone-700 hover:border-stone-900 transition-colors">{l.products}</Link>
        <Link to="/#contact" className="inline-flex items-center rounded-full border border-stone-300 px-7 py-3.5 text-[11px] uppercase tracking-[0.2em] text-stone-700 hover:border-stone-900 transition-colors">{l.contact}</Link>
      </div>
    </div>
  );
}
